import type { FaireBrandEntity } from "../../entity_types/brand";

export const b_bsvsnrtuas: FaireBrandEntity = {
  token: "b_bsvsnrtuas",
  type: "brand",
  name: "La Spora Tartufi",
  avatarUrl:
    "https://cdn.faire.com/fastly/d79c5429e90101d705b45d65c44dd0577dd89adabc155209bad94325dd9103ea.jpeg",
  bannerUrl:
    "https://cdn.faire.com/fastly/f12a2998dddaf0c1a674a5d329733367fb631d39ec51170918ae5257a4f3f208.jpeg",
  logoUrl:
    "https://cdn.faire.com/fastly/d79c5429e90101d705b45d65c44dd0577dd89adabc155209bad94325dd9103ea.jpeg",
  heroImageUrl:
    "https://cdn.faire.com/fastly/f12a2998dddaf0c1a674a5d329733367fb631d39ec51170918ae5257a4f3f208.jpeg",
  location: "ITA",
  minimumOrderDollars: 7,
  rating: 5,
  reviewCount: 21,
  isTopShop: true,
  isInsider: false,
  description:
    "Our family-run company has specialized over the years in the cultivation and marketing of fresh truffles, naturally present in our lands located in the upper valley of Sangro river, in an area straddling Abruzzo and Molise, which have always been generous producers of the precious tuber. She also dedicated herself to the preparation of preserved truffles, sauces, condiments and truffle food specialties.\n\n\nThe naturalness of the ingredients is accompanied by passion and seriousness in the choice and preparation of products, in order to bring their fresh goodness all over the world.\n\n\n\nOur products are totally handmade, without dyes or preservatives. \n\n",
  meta: {
    source: "api",
    importedAt: "2026-07-06T18:25:47.992Z",
    importedBy: "entity-db-cli",
  },
};
